import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Facewash = () => {

return (

<div>

<Navbar />
<Flexproducts type="facewash" />
<Header></Header>

</div>

);
};

export default Facewash;